<template>
  <NewTask
    taskType="audit_report"
    :docList="['Audit Report']"
  >
  </NewTask>
</template>

<script>
import axios from 'axios'
import NewTask from '@/components/NewTask.vue';

export default {
  components: {
    NewTask
  },
}
</script>
